import { ProgramSource } from '@optools/services/operator-gateway/types/generated/graphql';

export function formatProgramSourceValue(value: ProgramSource | undefined | null) {
  const displayValue = !value || value === ProgramSource.UNKNOWN ? 'None' : value;
  return displayValue.toLocaleLowerCase();
}
